import type { CurrentBalanceInsightsDTO } from "../models/currentBalanceInsightsDto";
import type { CurrentBalanceInsightsEntity } from "../../domain/entities/CurrentBalanceInsightsEntity";

export function currentBalanceInsightsDtoToEntity(
  dto: CurrentBalanceInsightsDTO,
): CurrentBalanceInsightsEntity {
  return {
    insights: (dto.insights ?? []).map((item) => ({
      accentColor: (item.accentColor ?? "neutral") as
        | "success"
        | "warning"
        | "neutral",
      description: item.description ?? "",
    })),
    noInsights: dto.no_insights ?? false,
    monthLabel: dto.month_label ?? "",
    message: dto.message ?? null,
  };
}
